
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  reactive,
  Ref,
  ref,
} from "vue";

import { IPaymentItem } from "@/models/payment";
import {
  IRequestCardInfo,
  IRequestInfoParams,
  RequestKindTypes,
} from "@/models/request";
import { useI18n } from "vue-i18n";
import RequestInfo from "./Request/RequestInfo";
import DateFormat from "@/utils/date-format";
import DoctorItem from "@/components/common/Doctors/DoctorItem.vue";
import RequestProgress from "@/components/common/Request/RequestProgress.vue";
import RequestProgressDesc from "@/components/common/Request/RequestProgressDescription.vue";
import { getDoctorImage } from "@/services/doctor";

export default defineComponent({
  name: "Orders",
  props: {
    item: {
      type: Object as PropType<IPaymentItem>,
      required: true,
    },
  },
  emits: ["CancelRequest", "deletedFile"],
  setup(props, { emit }) {
    const state = reactive({
      item: props.item,
      kind: props.item.RequestKind,
      isLoading: true,
    });

    const { t } = useI18n({ useScope: "global" });

    const onCancel = () => {
      emit("CancelRequest", state.item.RequestKey);
    };
    const cardInfo: Ref<IRequestCardInfo> = ref({} as IRequestCardInfo);

    const scheduledDate = computed(() => {
      const date = state.item.ScheduledDateTime
        ? state.item.ScheduledDateTime
        : 0;

      if (date === 0) return "";

      return `${DateFormat.splitDatetimeStringToString(date.valueOf())}`;
    });

    const insertDateTime = computed(() => {
      const date = state.item.InsertDateTime;
      if (!date) return "";

      return `${
        DateFormat.splitDatetime(state.item.InsertDateTime.valueOf()).date
      } ${t('requested')}`;
    });

    onMounted(async () => {
      state.item.Image = await getDoctorImage(state.item.DoctorKey);
      cardInfo.value = RequestInfo(
        state.item as IRequestInfoParams,
        t,
        onCancel
      );

      state.isLoading = false;
    });
    return { state, cardInfo, RequestKindTypes, scheduledDate, insertDateTime, t };
  },
  components: { RequestProgress, RequestProgressDesc, DoctorItem },
});
